import campaignConfig from '../../../../campaign-config/campaign.json';

export const tutorDetailsStarConfig = campaignConfig.tutor_details?.star || {};

export const resolveTutorDetailsStarAsset = (asset) => asset;